import React from 'react';

import { LoadingAnimate, LoadingContainer, Text } from './Loading-styled';

import LogoClassiAnimated from '../../../public/svg/logo-classi-animated.svg';

const Loading = () => {
    return (
        <LoadingContainer>
            <LoadingAnimate img={LogoClassiAnimated} />
            <Text>Carregando...</Text>
        </LoadingContainer>
    );
};

export default Loading;
